import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useState } from "react";
import { Clock, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { SollecitoSospesiDialog } from "@/components/SollecitoSospesiDialog";

const eur = (v) => Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
const ROLE = { agente: "Agente", interno: "Interno", collaboratore: "Collaboratore", eliminato: "Utente eliminato" };

export const SospesiSummaryDialog = ({ state, onOpenChange }) => {
  const { isReadOnly } = useAuth();
  const [sollecito, setSollecito] = useState(null);
  return (
  <>
  <SollecitoSospesiDialog person={sollecito} onClose={() => setSollecito(null)} />
  <Dialog open={state.open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="sospesi-summary-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-amber-700" /> Sospesi da recuperare
        </DialogTitle>
        <DialogDescription>Polizze sospese non ancora incassate, per persona.</DialogDescription>
      </DialogHeader>
      {state.loading ? (
        <div className="py-10 text-center text-sm text-slate-500">Caricamento…</div>
      ) : state.data ? (
        <div className="space-y-4">
          <div className="flex items-baseline justify-between rounded-lg bg-amber-50 border border-amber-200 p-4">
            <div className="text-sm text-amber-900">{state.data.count} polizz{state.data.count === 1 ? "a" : "e"} sospes{state.data.count === 1 ? "a" : "e"}</div>
            <div className="font-heading text-2xl font-bold text-amber-900 font-mono-num" data-testid="sospesi-summary-total">{eur(state.data.totale)}</div>
          </div>
          {state.data.old_count > 0 && (
            <div className="flex items-baseline justify-between rounded-lg bg-red-50 border border-red-200 px-4 py-2.5" data-testid="sospesi-summary-old">
              <div className="text-sm text-red-800 font-medium">{state.data.old_count} da più di 30 giorni: da sollecitare</div>
              <div className="font-mono-num font-semibold text-red-800">{eur(state.data.old_totale)}</div>
            </div>
          )}
          {state.data.per_persona.length === 0 ? (
            <div className="py-6 text-center text-sm text-slate-500" data-testid="sospesi-summary-empty">Nessun sospeso da recuperare.</div>
          ) : (
            <div className="border border-slate-200 rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-500 uppercase text-[11px]">
                  <tr>
                    <th className="text-left px-3 py-2">Persona</th>
                    <th className="text-right px-3 py-2">Polizze</th>
                    <th className="text-right px-3 py-2">Oltre 30 gg</th>
                    <th className="text-right px-3 py-2">Totale</th>
                    {!isReadOnly && <th className="px-3 py-2" />}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {state.data.per_persona.map((p) => (
                    <tr key={p.user_id} data-testid={`sospesi-row-${p.user_id}`}>
                      <td className="px-3 py-2">
                        <div className="font-medium text-slate-900">{`${p.nome} ${p.cognome}`.trim() || "—"}</div>
                        <div className="text-[10px] text-slate-400">{ROLE[p.role] || p.role}</div>
                      </td>
                      <td className="px-3 py-2 text-right font-mono-num">{p.count}</td>
                      <td className="px-3 py-2 text-right font-mono-num" data-testid={`sospesi-old-${p.user_id}`}>
                        {p.old_count > 0 ? (
                          <span className="inline-flex items-center rounded-full bg-red-100 text-red-700 px-2 py-0.5 text-xs font-semibold">{p.old_count} · {eur(p.old_totale)}</span>
                        ) : <span className="text-slate-300">—</span>}
                      </td>
                      <td className="px-3 py-2 text-right font-mono-num font-semibold">{eur(p.totale)}</td>
                      {!isReadOnly && (
                        <td className="px-3 py-2 text-right">
                          {p.role === "collaboratore" && (
                            <Button size="sm" variant="outline" onClick={() => setSollecito(p)} data-testid={`sospesi-sollecito-${p.user_id}`}>
                              <Mail className="w-3.5 h-3.5 mr-1" /> Sollecita
                            </Button>
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : null}
    </DialogContent>
  </Dialog>
  </>
  );
};
